import React from "react";
import IntegerInput from "../formElements/IntegerInput";
import FloatInput from "../formElements/FloatInput";
import {parseFloatWithPrecision} from "../../../support/math";


function CostCells(props) {

    function handleChange(event) {
        let updatedItem = props.item
        updatedItem[event.target.name] = event.target.value
        props.update(updatedItem, props.ndx, props.index, event.target.name)

    }

    return (
        <>
            <td>
                {!props.emptyCell &&  <IntegerInput name={'Pocet'}
                              value={props.item.Pocet}
                              onChange={(event) => handleChange(event)}/>}
            </td>
            <td>
                {!props.emptyCell &&  <FloatInput name={'Cena_Ks'}
                             // value={props.item.Cena_Ks !== null ?
                             //     props.item.Cena_Ks : props.item[props.singleName].Cena !== null ?
                             //         props.item[props.singleName].Cena : ""}
                              value={props.item.Cena_Ks !== null ? props.item.Cena_Ks : ""}
                              onChange={(event) => handleChange(event)}/>}
            </td>
            {props.separateSellPrice &&
            <td>
                {!props.emptyCell &&  <FloatInput name={'Predajna_Cena_Ks'}
                    // value={props.item.Cena_Ks !== null ?
                    //     props.item.Cena_Ks : props.item[props.singleName].Cena !== null ?
                    //         props.item[props.singleName].Cena : ""}
                              value={props.item.Predajna_Cena_Ks !== null ? props.item.Predajna_Cena_Ks : ""}
                              onChange={(event) => handleChange(event)}/>}
            </td>
            }
        </>
    )
}

export default CostCells
